module.exports = __webpack_public_path__ + "static/assets/29b32dd2ff827729020c2e3eaab644a1.svg";